import { customActivityButton } from './ActivityButton';

/** Button to view and perform a "Like" action on an item. */
export default customActivityButton('Like', 'Like', 'You liked', 'Liked');
